<template>
    <div id="messageModal">
        <b-button @click="showModal = true">
            {{ $t('Help') }}
        </b-button>

        <b-modal
            v-model="showModal"
            v-bind="$attrs"
            :title="$t('New issue')"
            hide-footer
        >
            <new-message @input="showModal = false"/>
        </b-modal>

    </div>
</template>

<script>
    import NewMessage from "@/components/issues/NewMessage";
    export default {
        name: "MessageModal",
        components: {NewMessage},
        props: {
            subject: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                showModal: false
            }
        }
    }
</script>

<style>
    #messageModal {
        position: fixed;
        right: -10px;
        top: 50%;
    }

    #messageModal > button {
        transform: rotate(-90deg);
    }
</style>
